import { render, staticRenderFns } from "./msgDialog.vue?vue&type=template&id=32a6eb93"
import script from "./msgDialog.vue?vue&type=script&lang=js"
export * from "./msgDialog.vue?vue&type=script&lang=js"
import style0 from "./msgDialog.vue?vue&type=style&index=0&id=32a6eb93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports